import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdsType } from '../settings/interfaces/ads';
import { ServerUrlService } from './server-url.service';

@Injectable({
	providedIn: 'root'
})
export class AdService {
	private headers: any
	constructor(private httpClient: HttpClient, private serverUrl: ServerUrlService) {
		this.headers = {
			headers: {
				'Content-Type': 'application/json'
			}
		}
	}

	getAds() {
		const url = this.serverUrl.getUrl()
		return this.httpClient.get(url + '/atendimento/painel/anuncios')
	}

	insertAd(formData: AdsType) {
		this.httpClient.post(
			`${this.serverUrl.getUrl()}/anuncios`,
			JSON.stringify(formData),
			this.headers
		).subscribe(
			(res) => {

			}
		)
	}

	updateAd(formData: AdsType) {
		this.httpClient.put(
			`${this.serverUrl.getUrl()}/anuncios`,
			JSON.stringify(formData),
			this.headers
		).subscribe(
			(res) => {

			}
		)
	}

}
